/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$( "body" ).on( "load ready", function() {
  let offset = 150;	
  var currentURL = window.location.href;
  let hash = currentURL.split("about-us")[1];
  let $target = $(hash);
  setTimeout(function(){ 
    if($target.length){
      $("html,body").stop().animate({
          scrollTop: $target.offset().top - offset
      }, 1000, function(){
        if(history.pushState) {
          history.pushState(null, null, hash);
        }
      });
    }
  }, 1000);
} );

$(document).ready(function() {

  // OFFERS
  $('body').on('click','.product-offer-header',function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });

  $("body").on("click", ".product-offer-code-block", function () {
    var copy_text = $(this).find('.product-offer-copy-code');
    var text = $(this).find('.product-offer-code').text();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  $('.videos_list .video_wp').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   arrows: true,
   dots: true,
   infinite:false,
   adaptiveHeight: false,
   autoplay: false,
   autoplaySpeed: 2000,
   prevArrow: $('.prev'),
   nextArrow: $('.next'),
   slide: '.video_main',
   responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
 });

  $('body').on('click','.videos_list .video_main .slide_video video', function(){
     if (this.paused) {      
      this.play()
      this.muted = false;
      $(this).closest('.video_wpp').removeClass('paused');
    } else {
      this.pause()
      this.muted = true;
      $(this).closest('.video_wpp').addClass('paused');
    }
  });

  $('body').on('click','.videos_list .play-video', function(){
    var video = $(this).closest('.video_wpp').find('.slideVideo').attr('id');
    document.getElementById(video).play();    
    document.getElementById(video).muted = false;
    $(this).closest('.video_wpp').removeClass('paused');
  });

  $(".video_wp").on("afterChange", function (event, slick, currentSlide, nextSlide){
    $('.videos_list').find('.video_main').each(function(){
      var vdid = $(this).find('video').attr('id');
      document.getElementById(vdid).pause();    
      document.getElementById(vdid).muted = false;
      $(this).find('.video_wpp').addClass('paused');
    });    
  });

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  
  if($('body').hasClass('template--product')){
    if($('.product-option-color').length > 0){
      var color_line_item_html = $('.product-option-color').html();
      var except_color_options = window.themeVariables.settings.except_color_options;
      var selectedVariant = window.themeVariables.settings.selectedVariant;
      var clicked = 0;  
      
      //IF THERE IS NO COLOR OPTION 
      var mi, mhasgo = true;
      for(mi = 1;mi<=3;mi++){    
        var exceptoptions = except_color_options.split(',');
        for(si = 0;si<=exceptoptions.length - 1;si++){      
          if($.trim(exceptoptions[si]) == $.trim(selectedVariant['option'+mi])){
            mhasgo = false;
          }
        }
      }
      var moptlen = selectedVariant.options.length;
      console.log(mhasgo);
      if(mhasgo){
        if($('.product-option-color').length == 0){
          $('.product-form__option-selector').eq(moptlen - 1).after(`<div class="product-option-step product-option-color product-custom-attribute">${color_line_item_html}</div>`); 
        }    
      }else{    
        if($('.product-option-color').length > 0){
          $('.product-option-color').remove();
        }
      }
      
      document.addEventListener('variant:changed', function(event) {
        let variant = event.detail.variant; // Gives you access to the whole variant details  
        let form = event.target;
        clicked++;   
        var i, hasgo = true;
        for(i = 1;i<=3;i++){
          var exceptoptions = except_color_options.split(',');
          for(si = 0;si<=exceptoptions.length - 1;si++){
            if($.trim(exceptoptions[si]) == $.trim(variant['option'+i])){
              hasgo = false;
            }
          }
        }
        var optlen = variant.options.length;
        if(hasgo){
          if($('.product-option-color').length == 0){
            $('.product-form__option-selector').eq(optlen - 1).after(`<div class="product-option-step product-option-color product-custom-attribute">${color_line_item_html}</div>`); 
          }    
        }else{    
          if($('.product-option-color').length > 0){
            $('.product-option-color').remove();
          }
        }
        setTimeout(function(){
          $('.product-option_steps-button.next').trigger('click');
        },500);    
      });
      
      $('body').on('change','[data-selector-type="block"].is_frames .block-swatch:first-child .block-swatch__radio', function(){
        if(clicked == 0){
          clicked++;
          var closest = $(this).closest('.is_frames');
          var mainparent = $(this).closest('.shopify-section--main-product');
          if(closest.find('[data-selector-type="block"] .block-swatch__radio:checked').closest('.block-swatch').hasClass('is-disabled') == false){
           mainparent.find('[data-product-add-to-cart-button] .loader-button__text').html(document.querySelector("[data-product-add-to-cart-button]").getAttribute("data-button-content")); 
          }      
          mainparent.find('[data-product-add-to-cart-button]').removeAttr('disabled');
          setTimeout(function(){
            $('.product-option_steps-button.next').trigger('click');
          },500);    
        }  
      });  
    }  
  
    $('body').on('keyup','.product-form__line-item-property-custom_text.has_mandatory textarea', function(){
      var str = $(this).val();       
      var lenqty = str.length;    
      if(lenqty > 0){
        $('[data-product-add-to-cart-button]').removeAttr('disabled');
      }else{
        $('[data-product-add-to-cart-button]').attr('disabled','disabled');
      }
    });  
  
    // $('body').on('change','.product-extra-faces #extra_faces_box', function(){
    //   var mainprice = parseInt($('.product__info [data-product-price-list]').attr('data-mainprice'));
    //   var compareprice = parseInt($('.product__info [data-product-price-list]').attr('data-compareprice'));
    //   var qty = parseInt($(this).closest('.product-extra-faces').find('.extra_faces_content [name="extraitem_qty"]').val());
    //   var prddta = JSON.parse($('.product-extra-faces').find('#extra_product').html());
    //   var vprice = prddta.product.variants[0].price;      
    //   var pricehtml = "";
    //   if($(this).is(':checked')){
    //     $(this).closest('.product-extra-faces').find('.extra_faces_content').slideDown();        
    //     if (compareprice > mainprice) {
    //       pricehtml += `<span class="price price--highlight"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice + (vprice * qty), currencyFormat)}</span>`;
    //       pricehtml += `<span class="price price--compare"><span class="visually-hidden"><s>${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(compareprice + (vprice * qty), currencyFormat)}</s><span class="limited-offer">Limited Offer (Inclusive of all taxes)</span></span>`;
    //     } else {
    //       pricehtml += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice + (vprice * qty), currencyFormat)}</span>`;
    //     }
    //   }else{
    //     $(this).closest('.product-extra-faces').find('.extra_faces_content').slideUp();
    //     if (compareprice > mainprice) {
    //       pricehtml += `<span class="price price--highlight"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice, currencyFormat)}</span>`;
    //       pricehtml += `<span class="price price--compare"><span class="visually-hidden"><s>${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(compareprice, currencyFormat)}</s><span class="limited-offer">Limited Offer (Inclusive of all taxes)</span></span>`;
    //     } else {
    //       pricehtml += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice, currencyFormat)}</span>`;
    //     }
    //   }
    //   $(this).closest('.product__info').find('[data-product-price-list]').html(pricehtml);
    // });
    
    $('body').on('change','.product-extra-faces .extra-faces-quantity_wp [name="extraitem_qty"]', function(){
      var qty = parseInt($(this).val());
      var formid = $(this).closest('.product-extra-faces').find('.faces-photos-input').attr('data-formid');
      var infotext = $(this).closest('.product-extra-faces').find('.faces-photos-input').attr('data-info');
      var newhtml = '';
      for(var i = 1;i <= qty;i++){
       newhtml += '<div class="product-form__line-item-selector"> <div class="product-form__line-item-info"> <label class="input__block-label" data-label="Choose image '+i+'">Choose image '+i+': <span data-content="'+infotext+'" class="variant-info">i</span></label> </div> <div class="product-form__line-item-property"> <div class="block-swatch-list block-swatch_input-file"> <input type="file" accept="image/*" class="input__field" name="properties[Extra image '+i+']" form="'+formid+'"> </div> </div> </div>'; 
      }    
      $(this).closest('.product-extra-faces').find('.faces-photos-input').html(newhtml);
      var mainprice = parseInt($('.product__info [data-product-price-list]').attr('data-mainprice'));
      var compareprice = parseInt($('.product__info [data-product-price-list]').attr('data-compareprice'));
      var prddta = JSON.parse($('.product-extra-faces').find('#extra_product').html());
      var vprice = prddta.product.variants[0].price;
      var pricehtml = "";
      if (compareprice > mainprice) {
        pricehtml += `<span class="price price--highlight"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(parseInt(mainprice + (vprice * qty)), currencyFormat)}</span>`;
        pricehtml += `<span class="price price--compare"><span class="visually-hidden"><s>${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(parseInt(compareprice + (vprice * qty)), currencyFormat)}</s><span class="limited-offer">Limited Offer (Inclusive of all taxes)</span></span>`;
      } else {
        pricehtml += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(parseInt(mainprice + (vprice * qty)), currencyFormat)}</span>`;
      }
      $(this).closest('.product__info').find('[data-product-price-list]').html(pricehtml);
    });
  
  }
  
  $('.product-faq-que').click(function(){
   $(this).toggleClass('active');
   $(this).next('.product-faq-ans').slideToggle();
  });

  
  
  // LINE ITEM PROPERTI JS
  $('body').on('click','.product-custom-attribute .block-swatch__item',function(){
    var selected_option = $(this).text();    
    $(this).parents('.product-form__line-item-selector').find('.block-swatch__item').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.product-form__line-item-selector').find('.product-form__line-item-value').text(selected_option);
    $(this).parents('.product-form__line-item-selector').find('.input__field').val(selected_option);
    // setTimeout(function(){
    //   $('.product-option_steps-button.next').trigger('click');
    // },500);    
  });
  $('body').on('click','.product-custom-attribute .combo-box__option-item',function(){
    var selected_option = $(this).text();
    $(this).parents('.product-option-step').find('.input__field').val(selected_option);   
  });


  //FOR GENERATING LI <li></li>
  for(i=1; i < $('.product-option-step').length; i++){
    $(".product-option_steps-dots").append("<li></li>");
  }
  
  //SHOW FIRST STEP AND HIDE PREV BUTTON
  $('.product-option-step:first').addClass('active');
  if ($( ".product-option-step:first-child" ).hasClass('active')) {
    $( ".product-option_steps-button.prev" ).hide();
  }

  //CLICK NEXT PREV BUTTON FUNCTINALITY
  $('body').on('click','.product-option_steps-button',function(){    
    var cur_pos = $('.product-option-step.active').index();    
    if($(this).hasClass('next')){
       cur_pos++;
    }else{
       cur_pos--;
    }

    if($('.product-option-step:eq('+cur_pos+')').length > 0 && cur_pos > -1){
       $('.product-option-step').removeClass('active');
       $('.product-option_steps-dots li').removeClass('selected');
       $('.product-option-step:eq('+cur_pos+')').addClass('active');
       $('.product-option_steps-dots li:eq('+cur_pos+')').addClass('selected');
     }   

    if ($( ".product-option-step:first-child" ).hasClass('active')) {
      $( ".product-option_steps-button.prev" ).hide();
    }else{
      $( ".product-option_steps-button.prev" ).show();
    }
    if ($( ".product-option-step:last-child" ).hasClass('active')) {
      $( ".product-option_steps-button.next" ).hide();
    }else{
      $( ".product-option_steps-button.next" ).show();
    }
  });

  // js/helper/currency.js
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  $('body').on('keypress','.pencil_carving_main textarea.input__field', function(){
    var max_chars = 12;
    $(this).closest('.product-form__line-item-property').find('.limit_reached').remove();
    var __this = $(this);
    if($(this).val().length > max_chars) {
       event.preventDefault();
       $(this).after('<span class="limit_reached">Maximum characters allowed: 13</span>');
       setTimeout(function(){
         __this.closest('.product-form__line-item-property').find('.limit_reached').remove();
       },3000);
       return false;
    }
  });
   $('body').on('keyup','.pencil_carving_main textarea.input__field', function(){
    var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    var str = $(this).val();   
    str = str.replace(/[^0-9a-zA-Z♡ ❤]/g ,"");
    $(this).val(str);
    var lenqty = str.replace(/\s/g, '').length;
    
    if(lenqty > 0){
      if(lenqty >= 3){
        $('.shopify-section--main-product [data-product-add-to-cart-button]').removeAttr('disabled');
        $('.required_badge').attr('hidden','hidden');
      }else{
        $('.shopify-section--main-product [data-product-add-to-cart-button]').attr('disabled','disabled');
        $('.required_badge').removeAttr('hidden');
      } 
      var mainprice = $('.product__info .product-meta__price-list-container [data-product-price-list]').attr('data-mainprice');
      var compprice = $('.product__info .product-meta__price-list-container [data-product-price-list]').attr('data-compareprice');
      mainprice = mainprice * lenqty;
      if(compprice != ''){
       compprice = compprice * lenqty; 
      }      
      var productPrices = $("[data-product-price-list]");    
      var pricehtml = '';
      if (compprice > mainprice) {
        pricehtml += `<span class="price price--highlight">${formatMoney(mainprice, currencyFormat)}</span>`;
        pricehtml += `<span class="price price--compare"><s>${formatMoney(compprice, currencyFormat)}</s><span class="limited-offer">Limited Offer (Inclusive of all taxes)</span></span>`;
      } else {
        pricehtml += `<span class="price price--large">${formatMoney(mainprice, currencyFormat)}</span>`;
      }
      productPrices.html(pricehtml);
    }else{
      $('.shopify-section--main-product [data-product-add-to-cart-button]').attr('disabled','disabled');
      $('.required_badge').removeAttr('hidden');
    }
    $(this).closest('.pencil_carving_main').find('[name="quantity"]').val(lenqty);
  });
  
});